import React, {useState} from 'react';
import {classes, style} from './doppe-viewer-share-modal-panel.st.css';
import {CommonClasses} from '@wix/devzai-common-client';
import {DoppeViewerModalPanel, DoppeViewerModalPanelLayout} from '../doppe-viewer-modal-panel/doppe-viewer-modal-panel';
import {DoppeViewerModalPanelHeader} from '../doppe-viewer-modal-panel-header/doppe-viewer-modal-panel-header';
import {ButtonType, flexColumn, useInnerWindowController} from '@wix/devzai-utils-react';
import {assertNotNullable, OmitStrict, PickKeys} from '@wix/devzai-utils-common';
import {useDoppeViewerLocales} from '../../client/doppe-viewer-locales/doppe-viewer-locales';
import {IDoppeViewerActionContext} from '../../doppe-sdk';
import {
    DoppeActionTypeWidgetInnerButton
} from '../doppe-action-type-widget-inner-button/doppe-action-type-widget-inner-button';
import {clipboardCopy} from '@wix/devzai-utils-dom';
import {
    DoppeActionTypeWidgetInnerTitle
} from '../doppe-action-type-widget-inner-title/doppe-action-type-widget-inner-title';
import {
    DoppeActionTypeWidgetInnerDescription
} from '../doppe-action-type-widget-inner-description/doppe-action-type-widget-inner-description';
import {doppeAppLayoutGap} from '@wix/doppe-ui';

export const DoppeViewerShareModalPanel = React.memo(function DoppeViewerShareModalPanel(props: DoppeViewerShareModalPanel.Props) {
    const {
        title,
        description,
        link,
        actionContext,

        className,
        ...restProps
    } = props;

    const modalController = assertNotNullable(useInnerWindowController());

    const [isCopied, setIsCopied] = useState(false);

    const viewerLocales = useDoppeViewerLocales();

    return (
        <DoppeViewerModalPanel
            {...restProps}
            className={style(classes.root, className, flexColumn())}
            mobileLayout={DoppeViewerModalPanelLayout.Drawer}
            desktopLayout={DoppeViewerModalPanelLayout.InnerCentered}
        >
            <DoppeViewerModalPanelHeader
                title={''}
                dismissButtonCallback={() => modalController.closeWindow()}
            />
            <div
                className={style(classes.shareLinkDetails, {}, flexColumn(), doppeAppLayoutGap(8))}
            >
                {
                    title || description ?
                        <div
                            className={style(classes.content, {}, flexColumn(), doppeAppLayoutGap(4))}
                        >
                            {
                                title ?
                                    <DoppeActionTypeWidgetInnerTitle
                                        className={style(classes.productName, {})}
                                    >
                                        {title}
                                    </DoppeActionTypeWidgetInnerTitle>
                                    : null
                            }
                            {
                                description ?
                                    <DoppeActionTypeWidgetInnerDescription
                                        className={style(classes.productDescription, {})}
                                    >
                                        {description}
                                    </DoppeActionTypeWidgetInnerDescription>
                                    :
                                    null
                            }
                        </div>
                        :
                        null
                }
                <a
                    href={link}
                    target={'_blank'}
                    className={style(classes.sharedLink, {}, CommonClasses.ellipsis)}
                >
                    {link}
                </a>
                <DoppeActionTypeWidgetInnerButton
                    className={style(classes.shareLinkButton)}
                    disabled={isCopied}
                    buttonType={ButtonType.NormalButton}
                    onClick={() => {
                        clipboardCopy(link);
                        setIsCopied(true);
                    }}
                >
                    {isCopied ? viewerLocales.shareCopied : viewerLocales.shareCopyLink}
                </DoppeActionTypeWidgetInnerButton>
            </div>
        </DoppeViewerModalPanel>
    );
});

export namespace DoppeViewerShareModalPanel {

    export type OmittedProps = PickKeys<DoppeViewerModalPanel.Props,
        'mobileLayout' | 'desktopLayout'
    >;

    export interface Props extends OmitStrict<DoppeViewerModalPanel.Props, OmittedProps> {
        title: string;
        description: string;
        actionContext: IDoppeViewerActionContext;
        link: string;
    }
}
